import { createStyle } from '@gluestack-style/react';

export const InputIcon = createStyle({
  props: {
    size: 'md',
  },
});
